module.exports = __webpack_public_path__ + "img/speakers-multimedia.0ad7abe0.png";